import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-file-drag-drop',
  templateUrl: './file-drag-drop.component.html',
  styleUrls: ['./file-drag-drop.component.scss'],
})
export class FileDragDropComponent {
  @Input() multiple = false;
  @Output() fileChanged = new EventEmitter<File[] | File>();

  onFileDropped(files: FileList) {
    if (this.multiple) {
      this.fileChanged.emit(Array.from(files));
    } else {
      this.fileChanged.emit(files.item(0) as File);
    }
  }

  fileBrowseHandler(target: HTMLInputElement) {
    if (!target.files) return;

    if (this.multiple) {
      this.fileChanged.emit(Array.from(target.files));
    } else {
      this.fileChanged.emit(target.files.item(0) as File);
    }
    target.value = '';
  }
}
